import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Tooltip from "@material-ui/core/Tooltip";
import { Info } from "lucide-react";

const useStyles = makeStyles((theme) => ({
  iconWrapper: {
    display: "inline",
    margin: theme.spacing(0, 1),
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    color: "oklch(37.9% 0.146 265.522)",
  },
}));

function MembershipDescription() {
  const classes = useStyles();

  return (
    <Typography
      variant="h5"
      display="inline"
      component="span"
      className={classes.title}
    >
      GIOCAMONDOCLUB
      <Tooltip title="Sei già registrato? Effetua il login. Ricorda di inserire l’email del genitore che ha effettuato la registrazione. Oppure prosegui e registrati. Importante: la registrazione all’area Giocamondo Club è obbligatoria per completare la prenotazione.">
        <span className={classes.iconWrapper}>
          <Info />
        </span>
      </Tooltip>
    </Typography>
  );
}

export default MembershipDescription;
